import { cn } from "@/lib/utils";
import avatar1 from "@/assets/social-proof/temoignage_3.webp";
import avatar2 from "@/assets/social-proof/temoignage_4.webp";
import avatar3 from "@/assets/social-proof/temoignage_5.webp";
import avatar4 from "@/assets/social-proof/temoignage_6.webp";
import avatar5 from "@/assets/social-proof/temoignage_7.webp";

const avatars = [
  { src: avatar1, alt: "Utilisateur UNOTIF" },
  { src: avatar2, alt: "Utilisateur UNOTIF" },
  { src: avatar3, alt: "Utilisateur UNOTIF" },
  { src: avatar4, alt: "Utilisateur UNOTIF" },
  { src: avatar5, alt: "Utilisateur UNOTIF" },
];

export const SocialProof = () => {
  return (
    <section className="pt-2 pb-0 sm:pt-3 sm:pb-1">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-4">
        <div className="flex items-center">
          {avatars.map((avatar, i) => (
            <img
              key={i}
              src={avatar.src}
              alt={avatar.alt}
              width={48}
              height={48}
              loading="eager"
              className={cn(
                "w-9 h-9 sm:w-12 sm:h-12 rounded-full border-2 border-[#91d0d8] object-cover",
                "transition-transform duration-300 hover:scale-110 hover:z-10 relative",
                i > 0 && "-ml-2.5 sm:-ml-3"
              )}
            />
          ))}
        </div>
        <div className="flex flex-col text-center sm:text-left">
          <span className="flex items-center justify-center sm:justify-start gap-0.5 text-[13px] sm:text-[17px] leading-snug" aria-label="Note 5 étoiles sur 5">
            {[0, 1, 2, 3, 4].map((i) => (
              <svg key={i} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#FACC15" className="w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" aria-hidden="true">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            ))}
          </span>
          <span className="text-[11px] sm:text-[14px] font-medium text-muted-foreground leading-snug">
            Utilisé par 600+ indépendants &amp; créateurs
          </span>
        </div>
      </div>
    </section>
  );
};
